// extracted by mini-css-extract-plugin
export var box = "Main-module--box--08f24";
export var box_md = "Main-module--box_md--b6a6a";
export var box_xmd = "Main-module--box_xmd--4309d";
export var box_flex = "Main-module--box_flex--d3deb";
export var box_lg = "Main-module--box_lg--f87a1";
export var box_sm = "Main-module--box_sm--cc65e";
export var box_outer = "Main-module--box_outer--05ef2";
export var box_whiteBg = "Main-module--box_white-bg--5d307";
export var box_noMarginBottom = "Main-module--box_no-margin-bottom--f27c0";
export var box_noPadding = "Main-module--box_no-padding--ec890";
export var box_outerGray = "Main-module--box_outer-gray--e265a";
export var box_dark = "Main-module--box_dark--7db94";
export var box_zIndex = "Main-module--box_z-index--9466e";
export var box_zIndex6 = "Main-module--box_z-index-6--1e36f";
export var box_eventsWithLine = "Main-module--box_events-with-line--d680a";
export var box_featuresAo = "Main-module--box_features-ao--f7a8e";
export var box_verticalPaddings = "Main-module--box_vertical-paddings--695db";
export var clearP = "Main-module--clearP--b12eb";
export var clearP_vc = "Main-module--clearP_vc--16f86";
export var content = "Main-module--content--a5aef";
export var topPaddingNone = "Main-module--topPaddingNone--f1b90";
export var bottomPaddingNone = "Main-module--bottomPaddingNone--e21a4";
export var marginDisable = "Main-module--marginDisable--2be9b";
export var whiteBG = "Main-module--whiteBG--ed023";
export var scrollY = "Main-module--scrollY--5f6bb";
export var stretchViewportHeight = "Main-module--stretchViewportHeight--eafa6";
export var hidden = "Main-module--hidden--578a3";
export var fadeInAnimation = "Main-module--fadeInAnimation--c6678";
export var placeHolderShimmer = "Main-module--placeHolderShimmer--d805b";